import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledContainer = styled.section`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  gap: ${spacing('xl')};
  padding-top: ${spacing('xl5')};
  padding-bottom: ${spacing('xl4')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  @media (max-width: ${screen('lgMax')}) {
    padding-top: ${spacing('xl')};
    padding-bottom: ${spacing('xl3')};
  }

  @media (max-width: ${screen('lgMax')}) {
    flex-direction: column;
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  max-width: 48rem;
  color: ${color('text_default_inverse')};
  font-size: ${fontSize('lg')};
  line-height: 1.6;

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
  }

  @media (max-width: ${screen('lgMax')}) {
    margin: ${spacing('lg')} auto 0;
  }

  ${Heading2}::before {
    left: 0;
    transform: unset;
  }

  a {
    color: ${color('link_inverse')};

    &:hover {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }

  strong {
    font-weight: ${fontWeight('extraBold')};
  }

  ul {
    padding-left: 1em;
  }

  li {
    list-style: disc;
  }
`;

export const StyledImage = styled.div`
  flex-shrink: 0;
  width: 27.5rem;
  margin: auto;

  @media (max-width: ${screen('mdMax')}) {
    width: 100%;
    margin: 0;
  }

  img {
    display: block;
  }
`;
